<template>
    <!-- <el-image
        :src="displayImage()"
        :fit="fit"
        :alt="alt"
        :referrer-policy="referrerPolicy"
        :lazy="lazy"
        :scroll-container="scroll"
        :preview-src-list="previewSrcList"
        :z-index="zIndex"
        :initial-index	="initialIndex"
    >
</el-image> -->
<img v-lazy="displayImage()" :key="src" />
</template>

<script>
    
    export default{
        name:"CacheImage",
        props:{
            src:String,
            fit: {
             Type:String,
             default: "none"
            },
            alt:String,
            referrerPolicy:String,
            lazy:Boolean,
            scroll:String,
            previewSrcList:Array,
            zIndex:Number,
            initialIndex:Number
        },
        data(){
            return {
                // testUrl: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fsafe-img.xhscdn.com%2Fbw1%2F4893c456-4d98-47ca-a57a-34d28b068e01%3FimageView2%2F2%2Fw%2F1080%2Fformat%2Fjpg&refer=http%3A%2F%2Fsafe-img.xhscdn.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1690200389&t=884ffbf19ad80560b1922ef31ecd9788"
            }
        },
        mounted(){
        },
        methods:{
            displayImage(){
                let url = this.src
                if(url == undefined) return ""
                let cacheData = this.$store.state.cacheImage
                // console.log("cachImageString",cacheData)
                if(cacheData != undefined && cacheData != ""){
                    try{
                        let jsData = JSON.parse(cacheData)
                        let cacheUrl =  jsData[url]
                        if(cacheUrl != undefined){
                            // console.log("使用缓存图片")
                            return cacheUrl
                        }
                    }catch(e){
                        // console.log("缓存报错", e)
                        this.$store.commit('clearCacheImage')
                    }
                }
                setTimeout(() => {
                    let img = new Image();
                    img.src = url;
                    img.lazy = url
                    img.crossOrigin = '*' // 允许跨域访问img.onload = function()var
                    img.onload = ()=>{ 
                        let canvas = document.createElement('canvas');
                        canvas.width =img.width;
                        canvas.height =img.height;
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(img,0,0,img.width,img.height);
                        let dataUrl = canvas.toDataURL('image/png'); // base64 的字符串
                        let cacheData = this.$store.state.cacheImage
                        if(cacheData == undefined || cacheData == ""){
                            let jsData = {}
                            this.$set(jsData, url,dataUrl)
                            this.$store.commit('saveCacheImage',JSON.stringify(jsData))
                        }else {
                            let jsData = JSON.parse(cacheData)
                            this.$set(jsData, url,dataUrl)
                            this.$store.commit('saveCacheImage',JSON.stringify(jsData))
                        }
                        // 缓存图片
                        // console.log('加载图片成功...');
                    }
                    img.onerror = (e)=>{
                        // console.log('加载图片失败...',e);
                    }
                }, 100);
                // console.log("使用原路径图片")
                return  url;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/common/cache_image.vue